import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { PainSection } from '../components/sections/PainSection';
import { PresentationSection } from '../components/sections/PresentationSection';
import { TriedSection } from '../components/sections/TriedSection';
import { RevealSection } from '../components/sections/RevealSection';
import { MechanismSection } from '../components/sections/MechanismSection';
import { IncludesSection } from '../components/sections/IncludesSection';
import { ForWhomSection } from '../components/sections/ForWhomSection';
import { TransformationSection } from '../components/sections/TransformationSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { Footer } from '../components/sections/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[var(--bg-deepest)] text-[var(--text-primary)] selection:bg-[var(--accent-teal)] selection:text-white" data-id="element-259">
      <HeroSection data-id="element-260" />
      <PainSection data-id="element-261" />
      <PresentationSection data-id="element-262" />
      <TriedSection data-id="element-263" />
      <RevealSection data-id="element-264" />
      <MechanismSection data-id="element-265" />
      <IncludesSection data-id="element-266" />
      <ForWhomSection data-id="element-267" />
      <TransformationSection data-id="element-268" />
      <TestimonialsSection data-id="element-269" />
      <FinalCTASection data-id="element-270" />
      <Footer data-id="element-271" />
    </main>;
}